import { BasicPlaceholder } from 'components/placeholder'
import {
    DataTableObjectType,
    TableData,
    buildDataTableObject,
} from 'utils/data'
import { extendWidthsForExtraColumns } from 'utils/table'
import { getLocationTableIndexes, pickData } from '../helpers'
import { Table } from 'components/table-compat/table-compat'
import { ErrorAlert } from 'components/error-fallback'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from '../../../locales/translation-keys'

interface INonStoreLocation {
    data: TableData | undefined
    isLoading: boolean
    currentLocation: string
    bottomLeftCell: string
    count: number
    isNextMonth?: boolean
}

export const NonStoreLocation = ({
    data,
    isLoading,
    currentLocation,
    bottomLeftCell,
    count,
    isNextMonth = false,
}: INonStoreLocation) => {
    const { payroll } = TRANSLATION_KEYS
    const { location } = payroll
    const { t, isEnglish } = useEssentials()
    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="table" rows={5} columns={5} />
            </div>
        )
    }
    if (!data) {
        return (
            <ErrorAlert variant="no-data" count={count}>
                {isNextMonth ? (
                    <p className="hc-ma-none">
                        {t(location.nextMonthUnavailable)}
                    </p>
                ) : null}
            </ErrorAlert>
        )
    }

    const baseWidths = isEnglish ? [65, 60, 65, 65, 80] : [65, 60, 125, 75, 80]

    const { startIndex: tableStartIndex, endIndex: tableEndIndex } =
        getLocationTableIndexes(currentLocation)
    const currentData = pickData(
        data,
        currentLocation,
        tableStartIndex,
        tableEndIndex,
        t(location.location),
    )
    const columnCount = currentData?.headings?.length ?? baseWidths.length
    const widths = extendWidthsForExtraColumns(baseWidths, columnCount, 75)
    const objParams = {
        currentData,
        widths,
        bottomLeftCell,
        pinFirstColumn: true,
    } as DataTableObjectType
    const obj = buildDataTableObject(objParams)
    return <Table data={obj} scrollableWidth={true} />
}
